var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-397.25 -229.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.375,3.375a7,7,0,1,0,7,7A7,7,0,0,0,10.375,3.375Zm0,13.418a6.418,6.418,0,1,1,6.418-6.418A6.425,6.425,0,0,1,10.375,16.793Z",
    transform: "translate(393.875 225.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.922,10.265c-.909,0-1.416.427-1.422,1.308h.4c-.013-.639.326-.978,1.008-.978a.851.851,0,0,1,.9.837,1.106,1.106,0,0,1-.408.8,1.651,1.651,0,0,0-.633,1.357h.4a1.2,1.2,0,0,1,.49-1.121,1.38,1.38,0,0,0,.545-1.056,1.166,1.166,0,0,0-1.27-1.148Z",
    transform: "translate(389.404 223.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.464,23.365a.354.354,0,1,0,.357.353A.355.355,0,0,0,17.464,23.365Z",
    transform: "translate(386.935 215.769)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ac49eaded61d03d14daad22e493f8558.svg";
export { ForwardRef as ReactComponent };